<template>
  <div class="employee-charge-privilege-block">
    <div>

      <div class="employee-charge-privilege-block__header">
        Категория: {{ info.category.name }}
      </div>
      <table class="employee-charge-privilege-block__table">
        <thead>
        <tr>
          <th>Площадь помещения</th>
          <th>Кол-во проживающих</th>
          <th>Площадь попадающая под льготу</th>
          <th>Количество прож. по льготе</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ info.area }}</td>
          <td>{{ info.living }}</td>
          <td>{{ info.privilege_area }}</td>
          <td>{{ info.privileged_users }}</td>
        </tr>
        </tbody>
      </table>

      <table class="employee-charge-privilege-block__table">
        <thead>
        <tr>
          <th>Кол-во проживающих родственников</th>
          <th>Соц. норма площади на 1 человека</th>
          <th>Соц. норма площади на семью</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ info.family_living }}</td>
          <td>{{ info.single_std_area }}</td>
          <td>{{ info.family_std_area }}</td>
        </tr>
        </tbody>
      </table>

      <table class="employee-charge-privilege-block__table">
        <thead>
        <tr>
          <th>Ограничение по площади</th>
          <th>Ограничение по людям</th>
          <th>Ограничение по типу собственности</th>
          <th>Ограничение нормативом</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <dictionary-item :dictionary="privilegeAreaLimits" :id="info.privilege.area_limit_type" />
          </td>
          <td>
            <dictionary-item :dictionary="privilegeUsersLimits" :id="info.privilege.users_limit_type" />
          </td>
          <td>
            <dictionary-item :dictionary="privilegeOwnershipLimits" :id="info.privilege.ownership_limit_type" />
          </td>
          <td>
            <dictionary-item :dictionary="privilegeStdLimits" :id="info.privilege.std_limit_type" />
          </td>
        </tr>
        </tbody>
      </table>

      <div class="employee-charge-privilege-block__info-row">
        <span class="employee-charge-privilege-block__info-label">Тип тарифа:</span>{{' '}}
        <dictionary-item :dictionary="privilegeTariffLimits" :id="info.tarif_type" />
      </div>
      <div class="employee-charge-privilege-block__info-row">
        <span class="employee-charge-privilege-block__info-label">Формула:</span> {{ info.formula }}
      </div>
    </div>
  </div>
</template>

<script>
import DictionaryItem           from "@/components/DictionaryItem";
import privilegeAreaLimits      from "@/dictionaries/privilegeAreaLimits";
import privilegeUsersLimits     from "@/dictionaries/privilegeUsersLimits";
import privilegeOwnershipLimits from "@/dictionaries/privilegeOwnershipLimits";
import privilegeStdLimits       from "@/dictionaries/privilegeStdLimits";
import privilegeTariffLimits    from "@/dictionaries/privilegeTariffLimits";

export default {
  name:       "ChargePrivilegeBlock",
  components: { DictionaryItem },
  props:      {
    info: {},
  },
  data() {
    return {
      privilegeAreaLimits,
      privilegeUsersLimits,
      privilegeOwnershipLimits,
      privilegeStdLimits,
      privilegeTariffLimits,
    };
  },
  computed:   {

  },
};
</script>

<style lang="scss">
.employee-charge-privilege-block {
  &__table {
    width: 100%;
    margin-bottom: 15px;
    border-collapse: collapse;

    td, th {
      border: 1px solid #ddd;
      text-align: center;
      padding: 10px;
      line-height: 1.1;
      font-size: .9rem;
    }
  }

  &__header {
    line-height: 1.1;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
    color: rgba(var(--app-heading-color), 1);
  }

  &__info-row {
    padding: 10px 0;
    line-height: 1.1;
  }

  &__info-label {
    font-weight: 500;
  }
}
</style>
